import speakingurl from 'speakingurl';
import {ProjectBuilderSettingsInterface} from "@tool/tool.types";

/**
 * @URL> https://pid.github.io/speakingurl/
 */

export const escapableReplacement = '~~*(replace)*~~';


export function getEscapableParts(string: string): RegExpMatchArray {
    // Checks if there are any strings inside of {}
    let matches = string.match(/{+[^}]+}+/g);

    return matches === null ? [] : matches;

}

export function replaceEscapablePartsPre(string: string, parts: RegExpMatchArray): string {
    parts.forEach((escapable: string) => {
        string = string.replace(escapable, escapableReplacement);
    });

    return string;
}


export function replaceEscapablePartsPost(string: string, parts: RegExpMatchArray): string {
    parts.forEach((escapable: string) => {
        string = string.replace(escapableReplacement, escapable);
    });

    return string;
}

export function slugify(string: string, lowercase: boolean): string {

    let escapableParts = getEscapableParts(string);

    let stringPre = replaceEscapablePartsPre(string, escapableParts);

    let slug = speakingurl(stringPre, {
        maintainCase: !lowercase,
        //  additionally allow chars: "-", "_", ".", "!", "~", "*", "'", "(", ")"
        // mark: true,
        custom: {
            '~~*(replace)*~~': '~~*(replace)*~~',
            '!': ''
        }
    });

    return replaceEscapablePartsPost(slug, escapableParts);

}


export default function ParameterNameGenerator(string: string, settings: ProjectBuilderSettingsInterface, forceSlugify: boolean = false): string {

    if (string === '') {
        return string;
    }

    let result = string;

    if (settings.slugify || forceSlugify) {
        result = slugify(result, settings.lowercase);

    } else {
        if (settings.lowercase) {
            result = result.toLowerCase();
        }
    }

    if (forceSlugify && !settings.lowercase) {
        result.toLowerCase()
    }

    // check for trailing dash
    if (string.endsWith('-') && !result.endsWith('-')) {
        result += '-';
    }

    return result;
}

